import { apiRequest } from './apiRequest';
import { CONST } from '../constant';

/**
 * get album list
 * @returns {Promise}
 */
export const getList = (cid, yyyymm, wide) => {
  return new Promise((resolve, reject) => {
    apiRequest(`/api/album/list/${cid}/${yyyymm || 'n'}/${wide ? 1 : 0}`, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

/**
 * @param appType: APP_TYPE: {
    POST = 'post',
    TALK = 'talk',
    ALBUM = 'album',
    CALENDAR = 'calendar',
   }
   @param id:number,
   @param fids:number[]
   @returns File[]
 */
export const getFiles = (appType, id, fids) => {
  return new Promise((resolve, reject) => {
    apiRequest(`/api/album/files/${appType}/${id}/${fids.join('-')}`, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

/**
 response is cmid array
 */
export const getShareMembers = fid => {
  return new Promise((resolve, reject) => {
    apiRequest(`/api/album/members/${fid}/`, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

/**
 this looks like getShareMembers above.
 response is like 'm1','m2'....
 this is allowed only creator
 */
export const getShareTargets = fid => {
  return new Promise((resolve, reject) => {
    apiRequest(`/api/album/targets/${fid}/`, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export const getViewItem = fid => {
  return new Promise((resolve, reject) => {
    apiRequest(`/api/album/viewItem/${fid}`, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export const deleteFile = $fid => {
  return new Promise((resolve, reject) => {
    let url = '/api/album/delete/' + $fid + '/';

    apiRequest(url, CONST.api_method.post)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export const updateRotate = data => {
  return new Promise((resolve, reject) => {
    let url = '/api/album/rotate';

    apiRequest(url, CONST.api_method.post, data)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export const updateDate = data => {
  return new Promise((resolve, reject) => {
    let url = '/api/album/date';

    apiRequest(url, CONST.api_method.post, data)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export const updateVisibility = data => {
  return new Promise((resolve, reject) => {
    let url = '/api/album/visibility';

    apiRequest(url, CONST.api_method.post, data)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export const updateShare = data => {
  return new Promise((resolve, reject) => {
    let url = '/api/album/share';

    apiRequest(url, CONST.api_method.post, data)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export default {
  getList,
  getFiles,
  getShareMembers,
  getShareTargets,
  getViewItem,
  deleteFile,
  updateRotate,
  updateDate,
  updateVisibility,
  updateShare,
};
